import type {SecureUploadFile, FailedFile, NewFile} from './types';
import {UPLOAD_CONFIG} from './constants';
import {AnalyticsService} from 'src/analytics';
import {getMessagingTrackingMetrics} from 'src/components/messaging/messaging-amplitude-helper';


export const getExistingFileNames = (
  uploadedFiles: SecureUploadFile[],
  newFiles: NewFile[],
  failedFiles: FailedFile[],
  rejectedFiles: NewFile[],
): string[] => [
  ...uploadedFiles.map((f) => f.fileName),
  ...newFiles.map((f) => f.file.name),
  ...failedFiles.map((f) => f.fileName),
  ...rejectedFiles.map((f) => f.file.name),
];

export const isFileLimitExceeded = (
  currentCount: number,
  newFilesCount: number,
): boolean => currentCount + newFilesCount > UPLOAD_CONFIG.maxFilesCount;

export const trackSecureFileUploadLinkSent = (messageBody: string) => {
  if (messageBody && messageBody.includes('<secure_upload_link>')) {
    const trackingDetails = getMessagingTrackingMetrics();
    AnalyticsService.track('Secure Upload Link Sent', trackingDetails);
  }
};
